import { lazy } from 'react'

const AssessmentListingComponent = lazy(async () => {
  const { AssessmentListing } = await import(
    /* webpackChunkName: "assessmentListing" */ './assessmentListing'
  )

  return {
    default: AssessmentListing
  }
})
const ExploreListingComponent = lazy(async () => {
  const { ExploreListing } = await import(
    /* webpackChunkName: "assessmentListing" */ './exploreListing'
  )

  return {
    default: ExploreListing
  }
})
const routes = [
  {
    path: '/assessments',
    authenticated: false,
    render(props) {
      return <AssessmentListingComponent {...props} />
    }
  },
  {
    path: '/explore',
    authenticated: false,
    render(props) {
      return <ExploreListingComponent {...props} />
    }
  }
]

export { routes }
